import * as Sentry from "@sentry/react";
import { createRoot } from "react-dom/client";
import "./lib/i18n";
import App from "./App.tsx";
import "./index.css";
import { initEventLogger } from "./lib/eventLogger";
import { initAcornSubscribers } from "./lib/acornSubscribers";
import { initContentInteractionSubscriber } from "./lib/contentInteractionSubscriber";
import { initMoriMessageSubscriber } from "./lib/moriMessageSubscriber";
import { initUpgradeToastSubscriber } from "./lib/upgradeToastSubscriber";
import { initReferralClaim } from "./lib/referralClaim";
import { initAppUpdateNotifier } from "./lib/appUpdateNotifier";

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.MODE,
  enabled: import.meta.env.PROD,
  tracesSampleRate: 0.2,
  replaysOnErrorSampleRate: 1.0,
  replaysSessionSampleRate: 0.05,
  // Replay is added lazily by src/lib/consent/sentryReplayLoader.ts after
  // the user grants consent (EEA/UK/CH) or on first render outside the region.
  integrations: [
    Sentry.browserTracingIntegration(),
  ],
  ignoreErrors: [
    "ResizeObserver loop limit exceeded",
    "Network request failed",
    "Load failed",
  ],
  beforeSend(event) {
    if (event.extra) {
      delete event.extra.memoryContent;
      delete event.extra.transcript;
    }
    return event;
  },
});


initEventLogger();                    // dev only — no-op in production
initAcornSubscribers();               // subscribe to events that award acorns
initContentInteractionSubscriber();   // write content_interactions on card events
initMoriMessageSubscriber();          // spawn user_card_instances on lifecycle events
initUpgradeToastSubscriber();         // Mori-voiced toast on tier upgrade
initReferralClaim();                  // call claim_referral RPC after signup via ?ref=
initAppUpdateNotifier();              // toast + reload prompt on chunk-hash drift after deploy

createRoot(document.getElementById("root")!).render(
  <Sentry.ErrorBoundary
    fallback={({ resetError }) => (
      <div style={{ padding: "24px", textAlign: "center", fontFamily: "system-ui" }}>
        <p>Mori ran into a problem. 🌰</p>
        <button onClick={resetError}>Try again</button>
      </div>
    )}
  >
    <App />
  </Sentry.ErrorBoundary>
);
